"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Transformer_1 = tslib_1.__importDefault(require("./Transformer"));
const Request = {
    fetch: async (method, url, options) => {
        const request = await Transformer_1.default.createRequestInfo(method, url, options);
        return Transformer_1.default.fetch(request);
    },
    get: async (url, options) => {
        const request = await Transformer_1.default.createRequestInfo("GET", url, options);
        return Transformer_1.default.fetch(request);
    },
    getPaginated: async (url, options) => Transformer_1.default.fetchPaginated(url, options),
    put: async (url, options) => {
        const request = await Transformer_1.default.createRequestInfo("PUT", url, options);
        return Transformer_1.default.fetch(request);
    },
    patch: async (url, options) => {
        const request = await Transformer_1.default.createRequestInfo("PATCH", url, options);
        return Transformer_1.default.fetch(request);
    },
    post: async (url, options) => {
        const request = await Transformer_1.default.createRequestInfo("POST", url, options);
        return Transformer_1.default.fetch(request);
    },
    delete: async (url, options) => {
        const request = await Transformer_1.default.createRequestInfo("DELETE", url, options);
        return Transformer_1.default.fetch(request);
    },
};
exports.default = Request;
//# sourceMappingURL=Request.js.map